import React from 'react'

function NewsBar() {
  return (
    <div className='flex justify-center bg-Black p-2 font-outfit text-White text-xs'> Portal Yiyer</div>
  )
}

export default NewsBar